import { cn } from "~/lib/ui";

export function DividerLine({ className }: { className?: string }) {
  return (
    <div className={cn("w-full", className)} aria-hidden="true">
      <hr style={{ borderTop: "0.0625rem solid #ccc" }} />
    </div>
  );
}
